import React from "react";
import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import keycloakInst from "./components/Service/keycloak";
import { FilterProvider } from "./context/Filter";
import Layout from "./components/Layout";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import { useIdleLogout } from "./components/Logout/Logoutuser";

import Login from "./components/Login/Login";
import Newlanding from "./pages/landing/Newlanding";
import Home from "./pages/Home/Landing";
import PiplineAndService from "./pages/piplineAndService";
import Services from "./pages/piplineAndService/Services";
import Complaints from "./pages/Complaints/Complaints";
import Vehicle from "./pages/Vehicle/Vehicle";
import VehicleDataProvider from "./context/VehicleDataProvider";
import ServicesDataProvider from "./context/ServicesDataProvider";
import Rto from "./pages/Rto";
import Jobcard from "./pages/Jobcard";
import EguruPvin from "./pages/eGuruPvin/EguruPvin";
import Jobcardindex from "./components/spareSales/JC/jcindex";
import SpareIndex from "./pages/SparesSales/SpareIndex";
import Fleetedge from "./pages/FleetEdge/fleetedge";
import ComplaintTat from "./pages/ComplaintTat/ComplaintStats";
import Analysis from "./pages/analysisData/Analysis";
import SsoIndexPage from "./pages/SsoPage/SsoIndexPage";
import FaultCode from "./pages/faultCodeAnalysis/Faultcode";
import Fleetinsight from "./pages/Fleetinsight/Fleetinsight";
import VasUnderFleet from "./pages/vasUnderFleet/VasUnderFleet";
import Arnenindex from "./pages/Arnenrichment/arnenindex";
import ApproverIndex from "./pages/approver/ApproverIndex";
import RevenueDetails from "./pages/piplineAndService/Revenuepop";
import PivinIndex from "./pages/newPivin/PivinIndex";
import NewLogin from "./pages/login/newLogin";
import Vas from "./pages/IframeEmbed/Vas";
import keycloakInstEguru from "./components/Service/keyclockEguru";

const initOptions = { onLoad: "check-sso" };

function App() {
  useIdleLogout(keycloakInst, 600000);
  (function saveUrlParams() {
    const url = new URL(window.location.href);

    const parArn = url.searchParams.get("parArn");
    const childArn = url.searchParams.get("childArn");
    const isDealer = url.searchParams.get("isDealer");
    const isVehicle360 = url.searchParams.get("isVehicle360");

    if (childArn || isVehicle360) {
      localStorage.setItem("incoming_childArn", childArn);
      localStorage.setItem("childArn", childArn);
      localStorage.setItem("isVehicle360", isVehicle360);
      localStorage.setItem("iframe_redirect", "piplineAndService");
    }

    if (parArn || isDealer) {
      localStorage.setItem("incoming_parArn", parArn);
      localStorage.setItem("isDealer", isDealer);
      localStorage.setItem("isVehicle360", isVehicle360);
      localStorage.setItem("iframe_redirect", "piplineAndService");
    }
  })();

  return (
    <ReactKeycloakProvider authClient={keycloakInst} initOptions={initOptions}>
      <FilterProvider>
        <Router>
          <Routes>
            <Route path="/eGuruPvin" element={<EguruPvin />} />
            <Route path="/landing" element={<Newlanding />} />
            <Route path="/" element={<Login />} />
            {/* <Route path="/home"
              element={
                <Layout>
                  <Home title="Customer 360" />
                </Layout>} /> */}
            <Route element={<PrivateRoute />}>
              <Route
                path="/home"
                element={
                  <Layout>
                    <Home title="Customer 360" />
                  </Layout>
                }
              />
              <Route
                path="/PiplineAndService"
                element={
                  localStorage.getItem("isDealer") === "true" ||
                    localStorage.getItem("isVehicle360") === "true" ? (
                    <PiplineAndService />
                  ) : (
                    <Layout>
                      <PiplineAndService />
                    </Layout>
                  )
                }
              />
              <Route
                path="/Services"
                element={
                  localStorage.getItem("isDealer") === "true" ? (
                    <ServicesDataProvider>
                      <Services />
                    </ServicesDataProvider>
                  ) : (
                    <Layout>
                      <ServicesDataProvider>
                        <Services />
                      </ServicesDataProvider>
                    </Layout>
                  )
                }
              />

              <Route
                path="/vehicle"
                element={
                  localStorage.getItem("isDealer") === "true" ? (
                    <VehicleDataProvider>
                      <Vehicle />
                    </VehicleDataProvider>
                  ) : (
                    <VehicleDataProvider>
                      <Layout>
                        <Vehicle />
                      </Layout>
                    </VehicleDataProvider>
                  )
                }
              />

              <Route
                path="/complaints"
                element={
                  localStorage.getItem("isDealer") === "true" ? (
                    <Complaints />
                  ) : (
                    <Layout>
                      <Complaints />
                    </Layout>
                  )
                }
              />

              <Route
                path="/Rto"
                element={
                  localStorage.getItem("isDealer") === "true" ? (
                    <Rto />
                  ) : (
                    <Layout>
                      <Rto />
                    </Layout>
                  )
                }
              />

              <Route
                path="/spare-sales"
                element={
                  localStorage.getItem("isDealer") === "true" ? (
                    <SpareIndex />
                  ) : (
                    <Layout>
                      <SpareIndex />
                    </Layout>
                  )
                }
              />

              <Route
                path="/jc"
                element={
                  localStorage.getItem("isDealer") === "true" ? (
                    <Jobcardindex />
                  ) : (
                    <Layout>
                      <Jobcardindex />
                    </Layout>
                  )
                }
              />

              <Route
                path="/Jobcard"
                element={
                  localStorage.getItem("isDealer") === "true" ? (
                    <Jobcard />
                  ) : (
                    <Layout>
                      <Jobcard />
                    </Layout>
                  )
                }
              />

              <Route
                path="/fleetedge"
                element={
                  localStorage.getItem("isDealer") === "true" ? (
                    <Fleetedge />
                  ) : (
                    <Layout>
                      <Fleetedge />
                    </Layout>
                  )
                }
              />

              <Route
                path="/vas-underFleet"
                element={
                  localStorage.getItem("isDealer") === "true" ? (
                    <VasUnderFleet />
                  ) : (
                    <Layout>
                      <VasUnderFleet />
                    </Layout>
                  )
                }
              />

              <Route
                path="/approver"
                element={
                  <Layout>
                    <ApproverIndex />
                  </Layout>
                }
              />
              <Route
                path="/fleet-insigths"
                element={
                  localStorage.getItem("isDealer") === "true" ? (
                    <Fleetinsight />
                  ) : (
                    <Layout>
                      <Fleetinsight />
                    </Layout>
                  )
                }
              />
              <Route
                path="/complaint-tat"
                element={
                  <Layout>
                    <ComplaintTat />
                  </Layout>
                }
              />
              <Route
                path="/sso"
                element={
                  <Layout>
                    <SsoIndexPage />
                  </Layout>
                }
              />
              <Route
                path="/analysis"
                element={
                  <Layout>
                    <Analysis />
                  </Layout>
                }
              />
              <Route
                path="/arnenrichment"
                element={
                  <Layout>
                    <Arnenindex />
                  </Layout>
                }
              />
              <Route
                path="/pvin"
                element={
                  <Layout>
                    <PivinIndex />
                  </Layout>
                }
              />
              <Route
                path="/vas-dashboard"
                element={
                  <Layout>
                    <Vas />
                  </Layout>
                }
              />
            </Route>
            <Route path="*" element={<Login />} />
          </Routes>
        </Router>
      </FilterProvider>
    </ReactKeycloakProvider>
  );
}

export default App;